<div class="chart-with-input-component" fxLayout="column">
    <div
        fxLayout="column"
        class="chart-with-input-component_form display-none-report"
    >
        <p class="text-12-semi-bold">
            Saldo Inicial de Caixa<i class="fa-solid fa-circle-info"></i>
        </p>
        <div
            class="chart-with-input-component_form-currency"
            fxLayout="row"
            fxLayoutAlign="space-between none"
        >
            <dsn-input
                style="width: 100%"
                [size]="'medium'"
                [type]="'text'"
                [placeholder]="'R$0,00'"
                [disabled]="false"
                [value]="currency"
                [name]="'currency'"
                [id]="'currency-field'"
                [isInvalid]="false"
                [noValidate]="false"
                [invalidMessage]="''"
            ></dsn-input>

            <div fxLayout="row" fxLayoutAlign="space-between none">
                <dsn-button-rounded
                    [type]="'secondary'"
                    [icon]="'fa-solid fa-arrows-rotate'"
                    [disabled]="false"
                    [size]="'medium'"
                    (onClick)="onUpdateCashBalance()"
                ></dsn-button-rounded>
                <dsn-button-rounded
                    [type]="'secondary'"
                    [icon]="'fa-solid fa-gear'"
                    [disabled]="false"
                    [size]="'medium'"
                ></dsn-button-rounded>
            </div>
        </div>
    </div>
    <div fxLayout="column">
        <app-highcharts-render
            style="height: 100%"
            [options]="options"
            [visualization]="visualization"
            [series]="series"
            [points]="points"
            [company]="company"
        ></app-highcharts-render>
    </div>
</div>
